export default __webpack_public_path__ + "static/media/button-x.291dc71f.svg";